(function () {
    // Old bookmarks/links used to point at /resources/#categories, back when "Browse by
    // HR Topic" was an in-page panel on the hub instead of its own page. Send those on
    // to the standalone HR Topics page so they still land somewhere useful.
    if (window.location.hash === '#categories') {
        window.location.replace('/resources/hr-topics/');
    }
}());
